'use strict';

var translations = {
    warnings: {
        straightRow: '請避免使用鍵盤同排的連續字母組合，例如「asdf」。',
        simpleRepeat: '請避免使用重複的單詞或字母，例如「aaa」和「abcabc」。',
        extendedRepeat: '請避免使用重複的單詞或字母，例如「aaa」和「abcabc」。',
        sequences: '請避免使用「abc」或「6543」這樣的連續字詞。',
        recentYears: '請避免使用最近的年份，例如「2020」。',
        dates: '請避免使用日期。',
        topTen: '請避免使用常見的密碼。',
        topHundred: '請避免使用常見的密碼。',
        common: '請避免使用常見的密碼。',
        similarToCommon: '請避免使用常見的密碼。',
        wordByItself: '請避免單獨使用一個單詞。',
        namesByThemselves: '請避免單獨使用名字或姓氏。',
        commonNames: '請避免單獨使用名字或姓氏。',
        userInputs: '',
        pwned: '',
        keyPattern: '',
    },
    suggestions: {
        useWords: '請使用兩個詞以上的長字串，並避免常見詞。',
        anotherWord: '請再加一兩個詞，不常見的會更好。',
        repeated: '請避免使用重複的單詞或字母，例如「aaa」和「abcabc」。',
        l33t: '避免可預測的替換詞，例如用「@」代替「a」（例如「@pple」代替「Apple」）。',
        reverseWords: '請避免使用把單詞倒過來的語詞，例如「elppa」（「apple」的相反排列）。',
        allUppercase: '全大寫容易被猜到的程度幾乎和全小寫一樣。',
        dates: '請避免使用日期。',
        associatedYears: '請避免使用日期。',
        recentYears: '請避免使用最近的年份，例如「2020」。',
        sequences: '請避免使用「abc」或「6543」這樣的連續字詞。',
        pwned: '',
        capitalization: '',
        longerKeyboardPattern: '',
        noNeed: '',
    },
    timeEstimation: {
        ltSecond: 'less than a second',
        second: '{base} second',
        seconds: '{base} seconds',
        minute: '{base} minute',
        minutes: '{base} minutes',
        hour: '{base} hour',
        hours: '{base} hours',
        day: '{base} day',
        days: '{base} days',
        month: '{base} month',
        months: '{base} months',
        year: '{base} year',
        years: '{base} years',
        centuries: 'centuries',
    },
};

export default translations;
//# sourceMappingURL=translations.js.map
